import React, { useState } from 'react';
import Modal from 'react-modal';
import * as type_btn from '../../../ressources/glossaires/glossaire_type_de_bouton';
import * as s from '../../../ressources/StyleGlobal/StyleGlobal';
import Bouton from '../Bouton/Bouton';
import styles from './PopupSmall.module.scss';

const PopupSmall = ({
  hideHeader,
  headerPopupText,
  eventAuClique,
  afficherLien,
  icone,
  texte_ouverture,
  hoverText,
  true: isRound,
  typeBoutonAffichage,
  children,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [overflowX] = useState('hidden');
  const [overflowY] = useState('hidden');
  const [inset] = useState('5% 0.1% 0% 21%');

  const toggleShowModal = () => {
    setShowModal(!showModal);
    if (typeof eventAuClique === 'function') {
      eventAuClique();
    }
  };

  let Textheader;
  let colorBg = [s.text_right, s.col_1];
  let classpopup = [s.row, s.text_right];

  if (!hideHeader) {
    classpopup.push([s.card_header, styles.styleB].join(' '));
    Textheader = (
      <span className={[styles.headerText, s.col_11].join(' ')}>
        {headerPopupText}
      </span>
    );
  } else {
    colorBg.push(styles.headerTextD);
    Textheader = (
      <span className={[styles.headerTextD, s.col_11].join(' ')}>
        {headerPopupText}
      </span>
    );
  }

  return (
    <>
      {afficherLien ? (
        <button
          type="button"
          className={styles.linkButton}
          onClick={toggleShowModal}
        >
          {icone}
          {texte_ouverture}
        </button>
      ) : (
        <Bouton
          hoverText={hoverText}
          ajoutClass={styles.format}
          rond={isRound}
          type={typeBoutonAffichage}
          cliquer={toggleShowModal}
        >
          {icone}
          {texte_ouverture}
        </Bouton>
      )}
      <Modal
        isOpen={showModal}
        onRequestClose={toggleShowModal}
        style={{
          overlay: {
            position: 'absolute',
            zIndex: '1000',
            border: 'black 1px solid',
            backgroundColor: 'transparent',
            transition: 'width 2s, height 4s',
          },
          content: {
            overflowX,
            overflowY,
            inset,
            width: '45%',
            height: 'fit-content',
            padding: '0px',
            boxShadow: '-5px 0px 5px rgba(0, 0, 0, 0.226)',
          },
        }}
      >
        <div className={classpopup.join(' ')}>
          {Textheader}
          <span className={colorBg.join(' ')}>
            <Bouton
              ajoutClass={styles.PositionBoutonFermeture}
              type={type_btn.fermer}
              rond={true}
              cliquer={toggleShowModal}
            />
          </span>
        </div>
        {children}
      </Modal>
    </>
  );
};

export default PopupSmall;
